import script from "./Article27.vue?vue&type=script&setup=true&lang=js"
export * from "./Article27.vue?vue&type=script&setup=true&lang=js"

import "./Article27.vue?vue&type=style&index=0&id=709d31c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709d31c2"]])

export default __exports__